import React, { useState } from "react"
import { useTranslation } from "react-i18next"
import { Card } from "ui/Card"
import { PricingTypeSelector } from "./PricingTypeSelector"
import { PricingTable } from "./PricingTable"
import { Button, Flex, Form } from "antd"
import { Icon } from "ui/Icon"
import { spacings } from "themes/variables"
import { generateUUID } from "components/trips/utils"
import { PRICING_TYPES } from "../utils/constants"
import { FullPayment } from "./FullPayment"
import { Deposit } from "./Deposit"
import { useDispatch, useSelector } from "react-redux"
import { errorFieldsSelector } from "modules/errors/selectors"
import { CustomInputError } from "ui/CustomInputError"
import { receiveErrors } from "modules/errors/reducer"
import PropTypes from "prop-types"

export const LengthAndRates = ({ form, isShowErrorMessage, setIsShowErrorMessage, onPriceInteraction }) => {
  const [t] = useTranslation()
  const dispatch = useDispatch()
  // Reactively watch pricing_type from the form; fall back to PER_PERSON
  const pricingType = Form.useWatch("pricing_type", form) || PRICING_TYPES.PER_PERSON
  const [expandedRowData, setExpandedRowData] = useState({})

  const [draftPrices, setDraftPrices] = useState([])

  const addNewPrice = () => {
    setDraftPrices((prev) => [...prev, { id: generateUUID() }])
    setExpandedRowData({})
    dispatch(
      receiveErrors({
        data: { message: { listing_media: [] } },
        showToast: false
      })
    )
    onPriceInteraction?.()
  }

  const errors = useSelector(errorFieldsSelector())
  return (
    <Card title={t("experiences.scheduling.sections.length_and_rates.title")} className="mb-3xl">
      <Flex vertical gap={spacings.XL}>
        <Flex align="center" justify="space-between" className="gap-3 lengthRatewrapper flex-wrap">
          <PricingTypeSelector
            value={pricingType}
            // Delegate setting directly to form so watcher updates automatically
            setPricingType={(val) => form.setFieldValue("pricing_type", val)}
            form={form}
            setIsShowErrorMessage={setIsShowErrorMessage}
            onPriceInteraction={onPriceInteraction}
          />
          <Button color="primary" variant="solid" size="large" onClick={addNewPrice}>
            <Icon type="feather" name="Plus" color="currentColor" />
            {t("experiences.scheduling.sections.length_and_rates.add_new")}
          </Button>
        </Flex>
        <PricingTable
          draftPrices={draftPrices}
          setDraftPrices={setDraftPrices}
          addNewPrice={addNewPrice}
          setExpandedRowData={setExpandedRowData}
          expandedRowData={expandedRowData}
          setPricingType={(val) => form.setFieldValue("pricing_type", val)}
          pricingType={pricingType}
          form={form}
          isFlatRate={pricingType === PRICING_TYPES.FLAT_RATE}
          onPriceInteraction={onPriceInteraction}
        />
        <Button color="primary" variant="link" size="large" className="p-0 mr-auto" onClick={addNewPrice}>
          <Icon type="feather" name="Plus" color="currentColor" />
          {t("experiences.scheduling.sections.length_and_rates.add_new")}
        </Button>
        {isShowErrorMessage && errors.listing_rates && <CustomInputError errorKey={errors.listing_rates[0]} />}
        <FullPayment />
        <Deposit form={form} />
      </Flex>
    </Card>
  )
}
LengthAndRates.propTypes = {
  form: PropTypes.object.isRequired,
  isShowErrorMessage: PropTypes.bool.isRequired,
  setIsShowErrorMessage: PropTypes.func.isRequired,
  onPriceInteraction: PropTypes.func
}
